<template>
  <!--
      作者：wangxw
      时间：2020-06-10
      描述：页面-页面列表
  -->
  <div class="user">
    <!--添加页面-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick()" v-auth="'/page/style/add'">添加风格</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="global_style_id" label="风格ID" width="80"></el-table-column>
          <el-table-column prop="name" label="风格名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="预览">
            <template slot-scope="scope">
              <div :style="{width: '80px', height: '25px', 'line-height': '25px', 'text-align': 'center',  backgroundColor: scope.row.content.titleBackgroundColor, color: scope.row.content.titleTextColor}">
                标题文本
              </div>
              <div v-if="scope.row.content.isReverseColor" :style="{width: '80px', height: '25px', 'line-height': '25px', 'text-align': 'center', 'margin-top': '3px', backgroundColor: scope.row.content.titleBackgroundColor, color: scope.row.content.reverseColor || colorReverse(scope.row.content.titleBackgroundColor)}">
                反色文本
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column prop="update_time" label="更新时间"></el-table-column>
          <el-table-column prop="is_default" label="设为默认">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_default" active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row.global_style_id)" type="text" size="small" v-auth="'/page/style/edit'">编辑</el-button>
              <el-button v-if="!scope.row.is_default" @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/page/page/delete'">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import PageApi from '@/api/page.js';
  import { colorReverse as colorR } from '@/utils/base.js'
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        PageApi.getGlobalStyleList({}, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {

        });
      },

      /*删除数据*/
      deleteClick(row) {
        let self = this;
        console.log(row)
        if (row.is_default) {
          self.$message({
            message: '默认风格不能删除',
            type: 'error'
          })
          return false
        }

        self.$confirm('此操作将删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          PageApi.deleteStyle({
            id: row.global_style_id
          }, true).then(data => {
            if (data.code === 1) {
              self.loading = false;
              self.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              self.getTableList();
            } else {
              self.loading = false;
            }
          }).catch(error => {
            self.loading = false;
          })
        }).catch(() => {}).finally(res => {
          self.loading = false;
        })
      },

      /*添加页面*/
      addClick() {
        this.$router.push('/page/style/add');
      },

      /*编辑*/
      editClick(global_style_id) {
        let self = this;
        self.$router.push({
          path: '/page/style/edit',
          query: {
            id: global_style_id
          }
        })

      },
      /* 设置默认 */
      isDefaultChange(row) {
        let self = this
        self.$confirm('此操作将改变商城的整体风格, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(1)
          self.loading = true;
          PageApi.setDefault({id: row.global_style_id}, true).then(data => {
            console.log(data)
            if (data.code === 1) {
              self.loading = false;
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              self.getTableList();
            } else {
              self.loading = false;
            }
          }).catch(error => {
            self.loading = false;
          });
        }).catch(() => {
          row.is_default = !row.is_default
        })
      },

      /**
       * 颜色取反色
       * @param oldColor
       * @returns {string}
       */
      colorReverse(oldColor) {
        return colorR(oldColor)
      }
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/page/style/index.vue